import { render, staticRenderFns } from "./clientDisplay.vue?vue&type=template&id=cfd67fe6&scoped=true&"
import script from "./clientDisplay.vue?vue&type=script&lang=js&"
export * from "./clientDisplay.vue?vue&type=script&lang=js&"
import style0 from "./clientDisplay.vue?vue&type=style&index=0&id=cfd67fe6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd67fe6",
  null
  
)

export default component.exports